import "./SubmitLead.scss";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Accordion } from "react-bootstrap";
import Select from "react-select";
import { useState, useEffect } from "react";
import { mobileChecker } from "../../utilities/regexChecker";
import sendRequest from "../../hooks/useAxios";
import toast, { Toaster } from "react-hot-toast";

export default function SubmitLead({
  customerType,
  leadReason,
  operatorList,
  setUpdater,
  setLoading,
}) {
  const [formDataSubmit, setFormDataSubmit] = useState({
    firstLead: { fullname: "", mobile: "", jender1: "" },
    secondLead: { fullname: "", mobile: "", jender2: "" },
    customerType: [],
    leadReason: [],
    operator: "",
  });
  const [defaultActiveKeyAcc, setDefaultActiveKeyAcc] = useState("");

  const changeHandler = (type, name, value) => {
    switch (type) {
      case "firstLead":
        setFormDataSubmit((prev) => {
          return {
            ...prev,
            firstLead: { ...formDataSubmit.firstLead, [name]: value },
          };
        });
        break;
      case "secondLead":
        setFormDataSubmit((prev) => {
          return {
            ...prev,
            secondLead: { ...formDataSubmit.secondLead, [name]: value },
          };
        });
        break;
      case "operator":
        setFormDataSubmit((prev) => {
          return {
            ...prev,
            operator: value,
          };
        });
        break;
      case "customerType":
        let specificIndex = formDataSubmit.customerType.findIndex(
          (c) => c == value.index
        );
        if (specificIndex != -1) {
          let temp = [...formDataSubmit.customerType];
          temp.splice(specificIndex, 1);
          setFormDataSubmit((prev) => {
            return { ...prev, customerType: temp };
          });
        } else {
          setFormDataSubmit((prev) => {
            return {
              ...prev,
              customerType: [...formDataSubmit.customerType, value.index],
            };
          });
        }
        break;
      case "leadReason":
        let specificIndexLead = formDataSubmit.leadReason.findIndex(
          (c) => c == value.index
        );
        if (specificIndexLead != -1) {
          let temp = [...formDataSubmit.leadReason];
          temp.splice(specificIndexLead, 1);
          setFormDataSubmit((prev) => {
            return { ...prev, leadReason: temp };
          });
        } else {
          setFormDataSubmit((prev) => {
            return {
              ...prev,
              leadReason: [...formDataSubmit.leadReason, value.index],
            };
          });
        }
        break;
    }
  };
  const [txtError, setTxtError] = useState({
    firstMobile: "",
    secondMobile: "",
  });
  const validateForm = () => {
    let validate = true;
    if (formDataSubmit.firstLead.mobile == "") {
      document.getElementById("first-mobile").scrollIntoView();
      setTxtError((prev) => {
        return { ...prev, firstMobile: "لطفا شماره تماس را وارد کنید." };
      });
      validate = false;
    } else if (!mobileChecker(formDataSubmit.firstLead.mobile)) {
      document.getElementById("first-mobile").scrollIntoView();
      setTxtError((prev) => {
        return {
          ...prev,
          firstMobile: "لطفا شماره تماس را به درستی وارد کنید.",
        };
      });
      validate = false;
    } else {
      setTxtError((prev) => {
        return {
          ...prev,
          firstMobile: "",
        };
      });
    }
    // if (
    //   formDataSubmit.secondLead.mobile != "" &&
    //   !mobileChecker(formDataSubmit.secondLead.mobile)
    // ) {
    //   document.getElementById("second-mobile").scrollIntoView();
    //   setDefaultActiveKeyAcc("2");
    //   setTxtError((prev) => {
    //     return {
    //       ...prev,
    //       secondMobile: "لطفا شماره تماس را به درستی وارد کنید.",
    //     };
    //   });
    //   validate = false;
    // } else {
    //   setTxtError((prev) => {
    //     return {
    //       ...prev,
    //       secondMobile: "",
    //     };
    //   });
    // }
    return validate;
  };
  const submitLeadFunc = (data) => {
    setLoading(true);
    let temp = {
      fullname1: data.firstLead.fullname,
      mobile1: data.firstLead.mobile,
      jender1: data.firstLead.jender1,
      jender2: data.secondLead.jender2,
      fullname2: data.secondLead.fullname,
      mobile2: data.secondLead.mobile,
      type: data.customerType.toString(),
      type_of_use: data.leadReason.toString(),
      operator_id: data.operator,
      reg_note: "",
      admin_note: "",
    };

    sendRequest("?action=add_lead", temp).then((data) => {
      if (data.data.state == 1) {
        setUpdater((prev) => !prev);
        setLoading(false);
        toast.success("سرنخ با موفقیت ثبت شد.");
        setFormDataSubmit({
          firstLead: { fullname: "", mobile: "", jender1: "" },
          secondLead: { fullname: "", mobile: "", jender2: "" },
          customerType: [],
          leadReason: [],
          operator: "",
        });
      } else {
        toast.error("ثبت سرنخ با مشکل مواجه شده است.");
        setLoading(false);
      }
    });
  };

  return (
    <div className="submit-lead p-3 mx-auto mt-5 shadow position-relative">
      <Form>
        <div className="text-center py-1 fw-bold fs-5 position-absolute  title px-3">
          ثبت سرنخ
        </div>
        <div className="d-flex mt-2 inputs align-items-center ">
          {/* <button onClick={() => setDefaultActiveKeyAcc("2")}>sss</button> */}
          <Form.Group className="d-flex flex-column m-2 gender">
            <Form.Label>جنسیت‌اول:</Form.Label>
            <div className="d-flex">
              {" "}
              <Form.Check
                label="خانم"
                name="jender1"
                type="radio"
                id={`reverse-radio-female1`}
                onClick={() => changeHandler("firstLead", "jender1", "2")}
                checked={formDataSubmit.firstLead.jender1 == "2" ? true : false}
              />
              <Form.Check
                className="ms-4"
                label="آقا"
                name="jender1"
                type="radio"
                id={`reverse-radio-male1`}
                onClick={() => changeHandler("firstLead", "jender1", "1")}
                checked={formDataSubmit.firstLead.jender1 == "1" ? true : false}
              />
            </div>
          </Form.Group>
          <Form.Group className="d-flex flex-column m-2 input-style">
            <Form.Label>نام‌و‌نام‌خانوادگی‌اول:</Form.Label>
            <Form.Control
              type="text"
              onChange={(e) =>
                changeHandler("firstLead", "fullname", e.target.value)
              }
              value={formDataSubmit.firstLead.fullname}
            />
          </Form.Group>
          <Form.Group
            className="d-flex flex-column m-2 input-style"
            id="first-mobile"
          >
            <Form.Label>موبایل‌اول:</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) =>
                changeHandler("firstLead", "mobile", e.target.value)
              }
              value={formDataSubmit.firstLead.mobile}
            />
            <Form.Text className="ms-2 text-danger">
              {txtError.firstMobile}
            </Form.Text>
          </Form.Group>
        </div>
        <hr />
        {/* {accordionComponent} */}
        <Accordion
          defaultActiveKey={defaultActiveKeyAcc}
          onSelect={(e) => setDefaultActiveKeyAcc(e)}
        >
          <Accordion.Item eventKey="2">
            <Accordion.Header>نفر دوم</Accordion.Header>
            <Accordion.Body>
              <div className="d-flex inputs align-items-center">
                <Form.Group className="d-flex flex-column m-2 gender">
                  <Form.Label>جنسیت‌دوم:</Form.Label>
                  <div className="d-flex">
                    {" "}
                    <Form.Check
                      label="خانم"
                      name="jender2"
                      type="radio"
                      id={`reverse-radio-female1`}
                      onClick={() =>
                        changeHandler("secondLead", "jender2", "2")
                      }
                      checked={
                        formDataSubmit.secondLead.jender2 == "2" ? true : false
                      }
                    />
                    <Form.Check
                      className="ms-4"
                      label="آقا"
                      name="jender2"
                      type="radio"
                      id={`reverse-radio-male1`}
                      onClick={() =>
                        changeHandler("secondLead", "jender2", "1")
                      }
                      checked={
                        formDataSubmit.secondLead.jender2 == "1" ? true : false
                      }
                    />
                  </div>
                </Form.Group>
                <Form.Group className="d-flex flex-column m-2 input-style">
                  <Form.Label>نام‌و‌نام‌خانوادگی‌دوم:</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) =>
                      changeHandler("secondLead", "fullname", e.target.value)
                    }
                    value={formDataSubmit.secondLead.fullname}
                  />
                </Form.Group>
                <Form.Group
                  className="d-flex flex-column m-2 input-style"
                  id="second-mobile"
                >
                  <Form.Label>موبایل‌دوم:</Form.Label>
                  <Form.Control
                    type="number"
                    onChange={(e) =>
                      changeHandler("secondLead", "mobile", e.target.value)
                    }
                    value={formDataSubmit.secondLead.mobile}
                  />
                  <Form.Text className="ms-2 text-danger">
                    {txtError.secondMobile}
                  </Form.Text>
                </Form.Group>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <hr />
        <div>
          <Form.Group className="my-3">
            <Form.Label>نوع مشتری:</Form.Label>
            <div className="d-flex flex-wrap">
              {customerType.map((value, index) => {
                return (
                  <Form.Check
                    key={`customer-${index}`}
                    className="d-flex align-items-center mx-3 checkbox"
                    type="checkbox"
                    id={value.id}
                    label={value.label}
                    onChange={(e) => changeHandler("customerType", "", value)}
                    checked={formDataSubmit.customerType.includes(value.index)}
                  />
                );
              })}
            </div>
          </Form.Group>
        </div>
        <hr />
        <div>
          <Form.Group className="my-3 ">
            <Form.Label>دلیل‌مصرف:</Form.Label>
            <div className="d-flex flex-wrap">
              {" "}
              {leadReason.map((value, index) => {
                return (
                  <Form.Check
                    key={`reason-${index}`}
                    className="d-flex align-items-center mx-3 checkbox"
                    type="checkbox"
                    id={value.id}
                    label={value.label}
                    onChange={(e) => changeHandler("leadReason", "", value)}
                    checked={formDataSubmit.leadReason.includes(value.index)}
                  />
                );
              })}
            </div>
          </Form.Group>
        </div>
        <hr />
        <div className="d-flex inputs">
          <div className="mx-2 half">
            <label className="mb-2">اپراتور:</label>
            <Select
              options={operatorList}
              value={operatorList.filter(
                (o) => o.value == formDataSubmit.operator
              )}
              onChange={(e) => changeHandler("operator", "", e.value)}
            />
          </div>
          <div className=" d-flex align-items-end  mx-2  submit-button half">
            <Button
              className="w-100"
              onClick={() => {
                if (validateForm()) submitLeadFunc(formDataSubmit);
              }}
            >
              ثبت
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
